import React from 'react';
import PropTypes from 'prop-types';
import getData from './getData';

/**
 *  Creates PageSchema component
 *
 */
function Page(_ref) {
  let {
    pageSchemaData = {},
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("script", Object.assign({
    "data-cmp": "orgSchema",
    type: "application/ld+json"
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: `${JSON.stringify(getData(pageSchemaData))}`
    }
  }, rest));
}
export default Page;